import { render, staticRenderFns } from "./cadEscala.vue?vue&type=template&id=4daa5744&scoped=true&"
import script from "./cadEscala.vue?vue&type=script&lang=js&"
export * from "./cadEscala.vue?vue&type=script&lang=js&"
import style0 from "./cadEscala.vue?vue&type=style&index=0&id=4daa5744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa5744",
  null
  
)

export default component.exports